import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Circle.scss';

export default class Circle extends Component {

  constructor(props) {
    super(props);

    // This binds all internal functions labled as "handler" to "this"
    
    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (name.toLowerCase().indexOf('handle') >= 0 && (this[name] instanceof Function)){
        this[name] = this[name].bind(this);
      }
    }
  }
  
  render(){
    let { borderWidth, borderColor, fillColor, left, top, width, height, position } = this.props;
    if (!left) {
      left = 0;
    }
    if (!top) {
      top = 0;
    }
    if (borderWidth == undefined){
      borderWidth = 1;
    }
    if (borderColor == undefined){
      borderColor = '#454545';
    }
    if (fillColor == undefined){
      fillColor = 'Transparent';
    }
    if (position == undefined){
      position = 'absolute';
    }

    let style = { left: left + 'px', top: top + 'px', width: width + 4 + 'px', height: height + 4 + 'px',
      position: position,
    };
    const cx = left + width / 2 + 2;
    const cy = top + height / 2 + 2;
    const r = width / 2;
    return(
      <svg height={height} width={width} style={style}>
        <circle cx={cx} cy={cy} r={r} stroke={borderColor} strokeWidth={borderWidth} fill={fillColor}/>
      </svg>
    );
  }
}

connect(Circle);




// WEBPACK FOOTER //
// ./src/components/graphics/Circle/index.js